<template>
  <Dialog
    :header="initialData ? 'Veterinário' : 'Adicionar veterinário'"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
  >
    <AppForm ref="form" :rules="{}" :values="model">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <AppFormItem label="Chave do Veterinário" :error="this.error.code">
            <span class="p-input-icon-right">
              <i v-if="loadingCheck" class="pi pi-spin pi-spinner" />
              <i v-else class="pi pi-search" />
              <InputText
                type="text"
                :disabled="initialData"
                v-model="model.inviteCode"
                @blur="checkCode()"
                @keyup.enter="checkCode()"
              />
            </span>
          </AppFormItem>
        </div>
        <div class="p-field p-col-12">
          <AppFormItem label="Nome">
            <InputText :disabled="true" v-model="model.name" />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <AppFormItem label="Documento">
            <InputText
              :disabled="true"
              v-model="model.document"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
            />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <AppFormItem label="Telefone">
            <InputText
              :disabled="true"
              v-model="model.phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
            />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12">
          <AppFormItem label="Email">
            <InputText :disabled="true" v-model="model.email" />
          </AppFormItem>
        </div>
      </div>
    </AppForm>
    <template #footer>
      <div class="p-grid p-jc-between">
        <div style="padding-left: 8px">
          <Button
            v-if="initialData"
            label="Remover"
            class="p-button-outlined p-button-danger"
            icon="pi pi-trash"
            @click="remove()"
          />
        </div>
        <div style="padding-right: 8px">
          <Button
            label="Cancelar"
            class="p-button-outlined p-mr-2"
            @click="cancel()"
          />
          <AppButton
            v-if="!initialData"
            label="Adicionar"
            :loading="loading"
            :disabled="!model.id"
            @click="save()"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { VetApi } from '../../../services/api';

const getDefaultValues = () => ({
  inviteCode: null,
  name: null,
  document: null,
  phone: null,
  email: null,
});

export default {
  name: 'VetDialog',
  props: {
    visible: Boolean,
    initialData: Object,
  },
  data() {
    return {
      model: getDefaultValues(),
      loading: false,
      loadingCheck: false,
      error: {
        code: null,
      },
    };
  },
  emits: ['invite', 'remove'],
  watch: {
    visible(newValue, oldValue) {
      if (newValue && !oldValue && this.initialData) {
        this.model = {
          ...this.initialData.vetAccount,
          _id: this.initialData.id,
        };
      }
    },
  },
  methods: {
    async checkCode() {
      this.loadingCheck = true;
      try {
        this.error.code = null;
        const vet = await VetApi.check(this.model.inviteCode);
        this.model = vet;
      } catch {
        this.error.code = { message: 'Veterinário não encontrado' };
      }
      this.loadingCheck = false;
    },
    async save() {
      try {
        this.loading = true;
        await VetApi.create({ code: this.model.inviteCode });
        this.$emit('invite');
        this.$emit('update:visible', false);
        this.model = getDefaultValues();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$emit('update:visible', false);
      this.model = getDefaultValues();
    },
    async remove() {
      await VetApi.delete(this.model._id);
      this.$emit('update:visible', false);
      this.$emit('remove', false);
      this.model = getDefaultValues();
    },
  },
};
</script>

<style scoped>
</style>